import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.217 4.25C7.8 4.25 4.25 7.738 4.25 12s3.55 7.75 7.967 7.75c3.541 0 6.53-2.244 7.572-5.331a.75.75 0 1 1 1.422.48c-1.248 3.697-4.81 6.351-8.994 6.351-5.21 0-9.467-4.124-9.467-9.25s4.257-9.25 9.467-9.25c2.527 0 4.827.968 6.527 2.55l1.902-1.904a.5.5 0 0 1 .854.354v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.354-.854l2.036-2.035a8.06 8.06 0 0 0-5.465-2.111"
  }));
}
var IcRefresh = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRefresh));

export { IcRefresh as I };
